import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Phone from "../utils/Phone";
import Direccion from "../utils/Direccion";
import { parseJwt, validateEmail, checkAuthorization } from "../utils/utils";
import { rolesOptions } from "./herlpers";
import controllerOrganizacion from "./../invitacion/duck";

const { Select2, Date, DateTime, Text } = Inputs;

const getListForSelect = (data) => {

  if (data && data instanceof Array) {
    let resultado = data.map((element) => {
      return { value: element._id, label: element.name };
    });

    return resultado;
  }
  return [];
};

function RegistroSuper() {

  const dispatch = useDispatch();
  const modelRegistro = useSelector((state) => state.registro);
  const modelOrganizaciones = useSelector((state) => state.organizaciones);
  const [organizacionID, setOrganizacionID] = useState(null);
  const [organizacionesForSelect, setOrganizacionesForSelect] = useState([]);
  const [opcionesRoles, setOpcionesRoles] = useState([]);
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [nombre, setNombre] = useState(null);
  const [rol, setRol] = useState("vendedor");
  const [direccion, setDireccion] = useState("");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [tel, setTel] = useState("+595");
  const [rolCreador, setRolCreador] = useState(null);

  useEffect(() => {
    
    checkAuthorization(["superadmin", "admin"])

    const token = localStorage.getItem("token");
    const decodedToken = parseJwt(token);
    setOpcionesRoles(rolesOptions(decodedToken.rol))
    setRolCreador(decodedToken.rol)
  }, [dispatch]);

  useEffect(() => {
    if (organizacionesForSelect && organizacionesForSelect.length === 0) {
      dispatch(controllerOrganizacion.getOrganizacionesThunk());
    }
  }, [organizacionesForSelect]);

  useEffect(() => {
    const data = modelOrganizaciones?.data?.data;
    const error = modelOrganizaciones?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerOrganizacion.duckGetOrganizaciones.actions.clear());
    }
    if (data) {
      setOrganizacionesForSelect(getListForSelect(data.data));
      dispatch(controllerOrganizacion.duckGetOrganizaciones.actions.clear());
    }
  }, [modelOrganizaciones]);

  useEffect(() => {
    const data = modelRegistro?.data?.data;
    const error = modelRegistro?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      alert("Registro exitoso");
      dispatch(controller.duck.actions.clear());
    }
  }, [modelRegistro]);

  function registrar() {
    const token = localStorage.getItem("token");
    const decodedToken = parseJwt(token);
    if (!validateEmail(username)) {
      alert("Por favor proporcione un email con el formato correcto");
      return;
    }
    if (
      !username ||
      !password ||
      !nombre ||
      !rol ||
      (rol === "superadmin" && !organizacionID)
    ) {
      return alert("Por favor complete todos los campos");
    }

    let data = {
      username,
      password,
      nombre: nombre,
      phoneNumber: tel,
      address: {
        direccion,
        lat,
        lng,
      },
      rol,
      organizacionID: rol === "superadmin" ? "Particular" : organizacionID ? organizacionID : "organizacion a manejar por backend",
      token
    };

    if (decodedToken.rol === "superadmin" || decodedToken.rol === "admin") {
      dispatch(controller.registroThunk(data));
    } else {
      alert("Rol no autorizado");
    }
  }
  return (
    <Content title="Registro" browserTitle="Registro" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Agregar usuario">
            {rolCreador === "superadmin" && (
              <Select2
                labelPosition="above"
                label="Organización"
                value={organizacionID}
                options={organizacionesForSelect}
                onChange={(e) => setOrganizacionID(e.target.value)}
              />
            )}

            <Text
              labelPosition="above"
              size="sm"
              label="Nombre completo"
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Select2
              labelPosition="above"
              label="Rol"
              value={rol}
              options={opcionesRoles}
              onChange={(e) => setRol(e.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Correo electrónico"
              onChange={(evt) => setUsername(evt.target.value)}
            />

            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label="Password"
              onChange={(evt) => setPassword(evt.target.value)}
            />

            <Phone value={tel} setValue={setTel} international={false} />

            <Direccion
              direccion={direccion}
              setDireccion={setDireccion}
              setLat={setLat}
              setLng={setLng}
            />

            <Button
              type="primary"
              text="Registrarse"
              pullRight={true}
              onClick={() => registrar()}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default RegistroSuper;
